import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import "./AppraisalProgress.css";
import AppraisalList from "./AppraisalList";
import Header from "./AppraisalList/component/Header/Header";

const YearlyAppraisalList = () => {
  const [tab, setTab] = useState("engine");

  return (
    <>
      <Header title="Yearly Appraisals" />
      <Nav variant="tabs" className="mb-3 px-3" activeKey={tab} onSelect={setTab}>
        <Nav.Item>
          <Nav.Link eventKey="engine">Yearly PAFs</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="aggregated">Aggregated Yearly PAFs</Nav.Link>
        </Nav.Item>
      </Nav>
      {tab === "engine" ? (
        <AppraisalList key="engine" baseFilters={{ frequency: "Yearly", listSource: "engine" }} />
      ) : (
        <AppraisalList key="aggregated" baseFilters={{ frequency: "Yearly", listSource: "aggregated" }} />
      )}
    </>
  );
};

export default YearlyAppraisalList;
